<template>
  <div>
    <v-row>
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="titulo-validador-laudos"
            v-model="titulo"
            class="my-0"
            label="Título"
            outlined
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>

      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header id="resultado-simulacao-laudo-incremental">
              <span style="font-size: 15px !important">Resultado da Simulação de Laudo Express</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="mx-auto">
                <v-col id="execucao-simulacao-laudo-incremental" cols="12" class="pl-2 pt-0">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-text-field
                      label="Resultado da Simulação de Laudo Express"
                      placeholder="Selecione um resultado"
                      outlined
                      readonly
                      :value="simulacaoLaudoIncrementalLabel"
                      :error-messages="errors"
                      @focus.close="dialogSeletorSimulacaoLaudoIncremental = true"
                    />
                  </validation-provider>
                  <dialog-seletor-simulacao-laudo-incremental
                    :activated.sync="dialogSeletorSimulacaoLaudoIncremental"
                    @selected="setSimulacaoLaudoIncremental($event)"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header id="arquivo-base-externa">
              <span style="font-size: 15px !important">Arquivo da Base Externa</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row>
                <v-col cols="12">
                  <v-alert dense outlined type="info" color="blue">
                    <div>
                      <a href="javascript:void(0)" @click="getArquivoModeloBaseExterna()">Clique aqui</a>
                      para baixar o modelo para a importação.
                      <br />
                      OBS: O arquivo deve conter as seguintes colunas:
                      <b>{{ arquivoBaseExternaCabecalho.join(', ') }}</b>
                      (exatamente nessa ordem e com esses nomes).
                      <br />
                      OBS²: O arquivo enviado precisa estar no formato
                      <b>UTF-8</b>
                      .
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-file-input
                      v-model="arquivoBaseExternaFileObj"
                      label="Arquivo CSV"
                      placeholder="Selecione um arquivo CSV"
                      outlined
                      accept=".csv, .zip"
                      truncate-length="30"
                      :loading="arquivoBaseExternaUploading"
                      loader-height="4"
                      :success="arquivoBaseExternaId && arquivoBaseExternaFileObj ? true : false"
                      :error-messages="errors"
                      @change="uploadNewFileBaseExterna($event)"
                      @click:clear="clearInputsArquivoBaseExterna()"
                    />
                  </validation-provider>
                  <validation-provider>
                    <input type="hidden" name="validate-upload-arquivo-ia" :value="arquivoBaseExternaId" />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row class="mb-n5 mt-n2">
                <parametros-arquivo-csv
                  :delimitador.sync="arquivoBaseExternaDelimitador"
                  :involucro.sync="arquivoBaseExternaInvolucro"
                  :escape.sync="arquivoBaseExternaEscape"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header id="testes-validacao">
              <span style="font-size: 15px !important">Testes para Validação</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <validation-provider v-slot="{ errors }" rules="required">
                <v-select
                  id="seletor-testes-validacao"
                  v-model="testesValidacao"
                  label="Testes"
                  :items="testesValidacaoItems"
                  outlined
                  chips
                  small-chips
                  multiple
                  :errors-message="errors"
                  class="ma-6 mr-10"
                />
              </validation-provider>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService';
  import ValidadorLaudosService from '@/services/ValidadorLaudosService';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue'),
      DialogSeletorSimulacaoLaudoIncremental: () =>
        import('@/components/general/selectors/GeneralDialogSeletorSimulacaoLaudoIncremental.vue')
    },

    data: () => ({
      dialogSeletorSimulacaoLaudoIncremental: false,
      testesValidacaoItems: []
    }),

    computed: {
      titulo: {
        get() {
          return this.$store.state.validadorLaudos.titulo;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', { titulo: value });
        }
      },
      arquivoBaseExternaId: {
        get() {
          return this.$store.state.validadorLaudos.arquivoBaseExterna.id;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            arquivoBaseExterna: { id: value }
          });
        }
      },
      arquivoBaseExternaFileObj: {
        get() {
          return this.$store.state.validadorLaudos.arquivoBaseExterna.fileObj;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            arquivoBaseExterna: { fileObj: value }
          });
        }
      },
      arquivoBaseExternaUploading: {
        get() {
          return this.$store.state.validadorLaudos.arquivoBaseExterna.uploading;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            arquivoBaseExterna: { uploading: value }
          });
        }
      },
      arquivoBaseExternaDelimitador: {
        get() {
          return this.$store.state.validadorLaudos.arquivoBaseExterna.delimitador;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            arquivoBaseExterna: { delimitador: value }
          });
        }
      },
      arquivoBaseExternaInvolucro: {
        get() {
          return this.$store.state.validadorLaudos.arquivoBaseExterna.involucro;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            arquivoBaseExterna: { involucro: value }
          });
        }
      },
      arquivoBaseExternaEscape: {
        get() {
          return this.$store.state.validadorLaudos.arquivoBaseExterna.escape;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            arquivoBaseExterna: { escape: value }
          });
        }
      },
      arquivoBaseExternaCabecalho: {
        get() {
          return this.$store.state.validadorLaudos.arquivoBaseExterna.cabecalho;
        }
      },
      simulacaoLaudoIncrementalId: {
        get() {
          return this.$store.state.validadorLaudos.simulacaoLaudoIncremental.id;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            simulacaoLaudoIncremental: {
              id: value
            }
          });
        }
      },
      simulacaoLaudoIncrementalNome: {
        get() {
          return this.$store.state.validadorLaudos.simulacaoLaudoIncremental.nome;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            simulacaoLaudoIncremental: {
              nome: value
            }
          });
        }
      },
      simulacaoLaudoIncrementalLabel() {
        return this.simulacaoLaudoIncrementalId
          ? `#${this.simulacaoLaudoIncrementalId} - ${this.simulacaoLaudoIncrementalNome}`
          : '';
      },
      testesValidacao: {
        get() {
          return this.$store.state.validadorLaudos.parametros.testesValidacao;
        },
        set(value) {
          this.$store.dispatch('setValidadorLaudos', {
            parametros: {
              testesValidacao: value
            }
          });
        }
      }
    },

    created() {
      this.getTestesValidacao();
    },

    mounted() {},

    methods: {
      getTestesValidacao() {
        ValidadorLaudosService.getTestesValidacao()
          .then((response) => {
            const data = response.data.data ?? response.data.testes;
            this.testesValidacaoItems = data.map((teste) => ({
              text: teste.descricao,
              value: teste.nome
            }));

            if (!this.$route.params.id) {
              this.testesValidacao = this.testesValidacaoItems.map((teste) => teste.value);
            }
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar os testes de validação disponíveis', '', {
              position: 'topRight'
            });
          });
      },

      exportData() {
        const vuexData = this.$store.state.validadorLaudos;

        return {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: vuexData.titulo,
          arquivo_base_externa_id: vuexData.arquivoBaseExterna.id,
          arquivo_base_externa_delimitador: vuexData.arquivoBaseExterna.delimitador,
          arquivo_base_externa_involucro: vuexData.arquivoBaseExterna.involucro,
          arquivo_base_externa_escape: vuexData.arquivoBaseExterna.escape,
          simulacao_laudo_incremental_id: vuexData.simulacaoLaudoIncremental.id,
          parametros: JSON.stringify(vuexData.parametros)
        };
      },

      getArquivoModeloBaseExterna() {
        this.$toast.info('Processando...', '', {
          position: 'topRight',
          timeout: 1250
        });

        ValidadorLaudosService.baixarArquivoModeloBaseExterna()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'Arquivo Base Externa.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo de Base Externa', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      },

      uploadNewFileBaseExterna(arquivo) {
        if (!arquivo) {
          this.clearInputsArquivoBaseExterna();
          return true;
        }

        this.arquivoBaseExternaId = '';
        this.arquivoBaseExternaUploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile, {})
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoBaseExternaDelimitador,
              this.arquivoBaseExternaInvolucro,
              this.arquivoBaseExternaEscape,
              this.arquivoBaseExternaCabecalho
            );
            this.arquivoBaseExternaId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', {
                position: 'topRight',
                timeout: 6000
              });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', {
                position: 'topRight'
              });
              console.error('Erro ao fazer upload: ', err);
            }

            this.arquivoBaseExternaFileObj = null;
          })
          .finally(() => (this.arquivoBaseExternaUploading = false));
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      },

      clearInputsArquivoBaseExterna() {
        this.arquivoBaseExternaId = '';
        this.arquivoBaseExternaFileObj = null;
        this.arquivoBaseExternaDelimitador = ';';
        this.arquivoBaseExternaInvolucro = '"';
        this.arquivoBaseExternaEscape = '"';

        this.$forceUpdate();
      },

      setSimulacaoLaudoIncremental(simulacao) {
        this.simulacaoLaudoIncrementalId = simulacao.id;
        this.simulacaoLaudoIncrementalNome = simulacao.titulo;
        this.dialogSeletorSimulacaoLaudoIncremental = false;
      },

      clearSimulacaoLaudoIncremental() {
        this.setSimulacaoLaudoIncremental({
          id: null,
          nome: ''
        });
      }
    },

    watch: {}
  };
</script>
